module.exports = __webpack_public_path__ + "media/images/icon/icons8-Help-c0d42e6a9d50ad1e6cc180c3f2c54346.png";